type ArrowRight = {
  fill: string
  width: string
  height: string
  title: string
  strokewidth: number
}

function ArrowRight(props: ArrowRight) {
  const fill = props.fill || 'currentColor'
  const strokewidth = props.strokewidth || 1
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'arrow right 2'

  return (
    <svg
      height={height}
      width={width}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <g
        fill={fill}
        strokeLinecap='square'
        strokeLinejoin='miter'
        strokeMiterlimit='10'
      >
        <line
          fill='none'
          stroke={fill}
          strokeLinecap='butt'
          strokeWidth={strokewidth}
          x1='2'
          x2='22'
          y1='12'
          y2='12'
        />
        <polyline
          fill='none'
          points='15,5 22,12 15,19 '
          stroke={fill}
          strokeWidth={strokewidth}
        />
      </g>
    </svg>
  )
}

export default ArrowRight
